import cx from 'classnames';
import React from 'react';

import Close from 'components/Icons/Close';
import Logo from 'components/Logo';
import colors from 'utils/colors';

import { useSidenavContext } from '../context';
import { HeadWrapper, StyledLogo, StyledClose } from './styles';

export type ComponentProps = {
  /**
   * optional url to go when the logo is clicked (Default to '#')
   */
  href?: string;
  /**
   * Optional wrapper class name for the component
   */
  className?: string;
  /**
   * Optional event handler when the service vic logo is clicked
   */
  onLogoClick?: () => void;
};

const Head: React.FC<ComponentProps> = ({ href = '#', className = '', onLogoClick = () => {} }) => {
  const { setIsOpen } = useSidenavContext();
  return (
    <HeadWrapper className={cx({ [className]: !!className })}>
      <StyledLogo target='_self'>
        <Logo href={href} onClick={onLogoClick} fill={colors.logoOrange} />
      </StyledLogo>
      <StyledClose onClick={() => setIsOpen(false)}>
        <Close fill={colors.logoOrange} />
      </StyledClose>
    </HeadWrapper>
  );
};

export default Head;
